import { render, staticRenderFns } from "./PageTemplateLeftMenuAndBody.vue?vue&type=template&id=53f65ade&scoped=true"
import script from "./PageTemplateLeftMenuAndBody.vue?vue&type=script&lang=js"
export * from "./PageTemplateLeftMenuAndBody.vue?vue&type=script&lang=js"
import style0 from "./PageTemplateLeftMenuAndBody.vue?vue&type=style&index=0&id=53f65ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f65ade",
  null
  
)

export default component.exports